import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { useSafeTimeout } from '../../ssr-util';
import { DiscountType, Voucher } from '../../interface/voucher.interface';
import { VoucherDetailModalComponent } from '../modal/voucher-modal/voucher-detail-modal/voucher-detail-modal.component';
import { VoucherService } from '../../services/voucher.service';

@Component({
  selector: 'app-voucher-item',
  templateUrl: './voucher-item.component.html',
  styleUrl: './voucher-item.component.scss'
})
export class VoucherItemComponent {

  @ViewChild("detailModal", { static: false }) detailModal: VoucherDetailModalComponent;

  @Input() voucher: Voucher;
  @Input() isCheckout: boolean = false;
  @Input() errorMessage?: string | null;

  @Output() selectVoucher = new EventEmitter<Voucher>();
  @Output() applyVoucher = new EventEmitter<Voucher>();

  discountType = DiscountType;

  modalOpen: boolean = false;

  private safeTimeout = useSafeTimeout();
  
  constructor(
    private voucherService: VoucherService
  ) { }

  async popupDetail(voucher: any) {
    if (!this.modalOpen) {
      this.modalOpen = true;
      this.safeTimeout(() => {
        this.detailModal.openModal();
      }, 10);
    }
  }

  onApplyVoucher(event: any, voucher: Voucher) {
    event.stopPropagation();
    voucher.isApplied = !voucher.isApplied;
    if (voucher.isApplied) {
      this.applyVoucher.emit(voucher);
    }
    else {
      this.voucherService.applyVoucher.emit(voucher);
    }
  }

  closeModal() {
    this.modalOpen = false;
  }
}
